import React from "react";
// Utils
import { orderBy } from "lodash";
import { formatPostTime, formatPeriod } from "@tvg/formatter/dates";
// Types
import { SurfaceChanges } from "@tvg/ts-types/Race";
import { Icon, Paragraph } from "@tvg/design-system";

import {
  ChangesProcessed,
  processSurfaceRaceChanges
} from "./changesProcessor";

// Components
import {
  List,
  Time,
  Dt,
  Dl,
  ChangeLblContainer,
  ChangesDivisor
} from "./styled-components";

interface SurfaceChangesProps {
  changes: SurfaceChanges;
}

const SurfaceChangesList = ({ changes }: SurfaceChangesProps) => {
  const surfaceChanges: ChangesProcessed[] = processSurfaceRaceChanges(changes);

  return (
    <ChangesDivisor>
      <Paragraph qaLabel="surface-changes" fontFamily="bold">
        SURFACE
      </Paragraph>
      <List data-qa-label="surfaceChangesList">
        {orderBy(surfaceChanges, ["date"], ["desc"]).map(
          (change: ChangesProcessed) => (
            <li key={`surface-change-${change.date}-${change.keyword}`}>
              <Time>
                {formatPostTime(change.date)} {formatPeriod(change.date)}
              </Time>
              <Dl>
                <Dt>
                  <strong>{change.keyword}</strong>
                  <ChangeLblContainer>
                    <span>{change.oldValue || "Set to\u00A0"}</span>
                    {change.newValue && change.oldValue && (
                      <Icon name="arrowRight" size="s" ml="4" mr="4" />
                    )}
                    {change.newValue && <strong>{change.newValue}</strong>}
                  </ChangeLblContainer>
                </Dt>
              </Dl>
            </li>
          )
        )}
      </List>
    </ChangesDivisor>
  );
};

export default SurfaceChangesList;
